import Vue from 'vue'
import Router from 'vue-router'
const Agreements = () => import(
  /* webpackChunkName: "Agreements" */ '../views/agreements/Agreements.vue')
const ClubVisits = () => import(
  /* webpackChunkName: "ClubVisits" */ '../views/clubVisits/ClubVisits.vue')
const ClubVisitsMobile = () => import(
  /* webpackChunkName: "ClubVisitsMobile" */ '../views/clubVisits/ClubVisitsMobile.vue')
const PersonalTraining = () => import(
  /* webpackChunkName: "PersonalTraining" */ '../views/personalTraining/PersonalTraining.vue')

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/agreements',
    name: 'Agreements',
    component: Agreements
  },
  {
    path: '/club-visits',
    name: 'ClubVisits',
    component: () => {
      return new Promise((resolve) => {
        if (window.innerWidth < 768) {
          ClubVisitsMobile().then((response) => {
            resolve(response)
          })
        } else {
          ClubVisits().then((response) => {
            resolve(response)
          })
        }
      })
    }
  },
  {
    path: '/personal-training',
    name: 'PersonalTraining',
    component: PersonalTraining
  },
  {
    path: '*',
    redirect: '/personal-training'
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js